import { render, staticRenderFns } from "./ResultsInfo.vue?vue&type=template&id=7fe23edc&scoped=true&lang=pug"
import script from "./ResultsInfo.vue?vue&type=script&lang=js"
export * from "./ResultsInfo.vue?vue&type=script&lang=js"
import style0 from "./ResultsInfo.vue?vue&type=style&index=0&id=7fe23edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe23edc",
  null
  
)

export default component.exports